//import React from 'react';


const projects = [
  {
    title: 'PlaySpace',
    content: 'A music sharing App.',
    repoLink: 'https://github.com/tinastanczyk/PlaySpace',
    deployLink: 'https://blooming-taiga-58693.herokuapp.com/'
  },
  {
    title: 'Dungeons, Notes, Dragons',
    content: 'A character sheet and note-taking app for Dungeons and Dragons.',
    repoLink: 'https://github.com/tinastanczyk/dungeons_notes_dragons',
    deployLink: 'https://agile-tundra-64769.herokuapp.com/'
  },
  {
    title: 'E-Commerce Back-End',
    content: 'An E-commerce platform.',
    repoLink: 'https://github.com/tinastanczyk/e-commerce-back-end',
    deployLink: 'https://drive.google.com/file/d/1Lq0hUUpFLQR3HXq8-fWSlQx3jzu9OHyt/view'
  },
  {
    title: 'Text Editor PWA',
    content: 'A notes App with on and offline functionality.',
    repoLink: 'https://github.com/tinastanczyk/text-editor-pwa',
    deployLink: 'https://pacific-island-97886.herokuapp.com/'
  },
  {
    title: 'Social Network API',
    content: 'A back-end social network App.',
    repoLink: 'https://github.com/tinastanczyk/social-network-api',
    deployLink: 'https://drive.google.com/file/d/1yMK4r8R4yrf5IVxSux9LzfVVd13MGXjY/view'
  },
  {
    title: 'Note Taker',
    content: 'An App for taking notes.',
    repoLink: 'https://github.com/tinastanczyk/noteTaker',
    deployLink: 'https://tinas-note-taker.herokuapp.com/'
  },
  {
    title: 'Team Profile Generator',
    content: 'A team builder App.',
    repoLink: 'https://github.com/tinastanczyk/team-profile-generator'
  }
]

export default projects;